import { authHeader, handleResponse } from "../helpers";

export const productPromotionService = {
  payout,
  refund
};

function payout(id,data) {
  let formBody = [];
  for (let property in data) {
    let encodedKey = encodeURIComponent(property);
    let encodedValue = encodeURIComponent(data[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  const requestOptions = {
      method: 'PUT',
      headers: { ...authHeader() , 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formBody
  };
  return fetch(`${process.env.REACT_APP_API_URL}api/v1/product-promotion/event-completed/${id}`, requestOptions)
      .then(handleResponse);
}

function refund(id,data) {
  let formBody = [];
  for (let property in data) {
    let encodedKey = encodeURIComponent(property);
    let encodedValue = encodeURIComponent(data[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  const requestOptions = {
      method: 'PUT',
      headers: { ...authHeader() , 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formBody
  }
  return fetch(`${process.env.REACT_APP_API_URL}api/v1/product-promotion/merchantRefund/${id}`, requestOptions)
  .then(handleResponse);

}
